import {ReactElement} from "react"
import {Button} from "antd"
import {t} from "@ui/common/intl"
import PoolModal from "@ui/components/common/PoolModal"

type TConfirmationModalProps = {
  show?: boolean
  onConfirm: () => void
  onClose: () => void
  title: string
  text: string
  buttonTitle?: string
}
const ConfirmationModal = ({
  show,
  onConfirm,
  onClose,
  title,
  text,
  buttonTitle = t("button.exit")
}: TConfirmationModalProps): ReactElement => {
  return (
    <PoolModal
      className="profile-confirm-modal"
      onCancel={onClose}
      open={show}
      closable={true}
      width=""
      centered={true}
      title={title}
      footer={
        <div className="buttons">
          <Button className="button-regular" onClick={onConfirm}>
            {buttonTitle}
          </Button>
        </div>
      }
    >
      {text}
    </PoolModal>
  )
}

export default ConfirmationModal
